export enum NumberFormatType {
  Automatic, // default
  Number,
  Percent,
  Currency,
  Accounting,
  DateNTime,
  Duration,
  Fraction,
  Scientific,
  Text,
  Custom,
}

export enum NegativeNumFormatType {
  StandardWithSign = '1', //-1234,
  NegativeAsRed = '2', // 1234 - in red color,
  NegativeAsRedWithSign = '3', // -1234 - in red color,
  NegativeInBrackets = '4',
  NegativeAsRedInBrackets = '5',
}

export interface NumberFormatConfigs {
  type: NumberFormatType;
  currencyCode: string;
  negativeFormat: NegativeNumFormatType;
  // locale: string;
  // decimalSeparator: boolean;
  showThousandSeparator: boolean;
  decimalPlaces: string;
  dateFormat: string;
  timeFormat: string;
  durationFormat: string;
  fractionFormat: string;
  customCode: string;
}

export interface NumberFormat {
  type: NumberFormatType;
  code: string;
}

// The 'NumberFormats' object contains notations for cell areas (e.g., [rs: 0, cs: 1, re: 0, ce: 2] represents 'B1:C1') &  cell address (e,g [0, 1] represents B1).
// Each address in 'NumberFormats' is unique and cannot be repeated, (intersections will split address).
// Number formats (e.g., `0,1,0,2`) can be accessed using 'numberFormatMatrix' indexed by column indexes.
// We are using Array-Address(`0,1,0,2`) instead of address (A1, B2 , B1:B1000) because array-address notations are 75% faster then address and we need numberFormat while rendering cells

export interface NumberFormats {
  [arrayAddress: string]: NumberFormat;
}

// The 'NumberFormatMatrix' organizes number format addresses by columns, enabling quick and easy retrieval.
// It exclusively stores range number formats and does not include individual cell area addresses.
export type NumberFormatMatrix = string[][];

export interface SheetNumberFormats {
  numberFormats: NumberFormats; // Stores notations for both individual cells and cell areas.
  numberFormatMatrix: NumberFormatMatrix; // Organizes range number format addresses by columns.
}
